import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContactSupport() {
	const { t } = useTranslation('acs');
	return (
		<div style={{ textAlign: 'center', fontFamily: 'Source Sans Pro' }}>
			<a href="mailto:support@textrecruit.com">{t('contact_support')}</a>
		</div>
	);
}
